module.exports = __webpack_public_path__ + "media/images/05_exterier_F_JPEG-eabacf03.jpg";